import { request } from 'src/helpers/api';
import type { AxiosResponse } from 'axios';

type ApiResponse = Promise<AxiosResponse>;

export const getDashboardDetails = (params: Record<string, unknown>): ApiResponse => (
  request({
    method: 'GET',
    url: '/api/dashboard',
    params,
  })
);
export const deEscalationServiceInterest = (): ApiResponse => (
  request({
    method: 'POST',
    url: '/api/notify/de-escalation-service-interest',
  })
);

export const answeringServiceInterest = (): ApiResponse => (
  request({
    method: 'POST',
    url: '/api/notify/after-hours-maintenance-answering-service-interest',
  })
);

export const globalSearch = (params: Record<string, unknown> = {}): ApiResponse => (
  request({
    method: 'GET',
    url: '/api/service-request/search',
    params,
  })
);
